<template>
  <v-card>
    <router-view :key="$route.fullPath"></router-view>
    <v-dialog v-model="shareDialog" persistent max-width="1150px" class="mt-0">
      <v-form ref="shareForm" onSubmit="return false;">
        <v-card>
          <v-card-title>
            {{ $t('message.order.sendOrder') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-2">
            <v-col cols="12">
              <v-row>
                <v-text-field outlined dense v-model="mails" ref="autoFocus" :label="$t('message.customer.email')" :rules="$_requiredValidation"
                  persistent-hint :hint="$t('message.common.add_extra_mails')"></v-text-field>
              </v-row>
              <v-row>
                <v-text-field outlined dense v-model="subject" ref="autoFocus" :rules="$_requiredValidation"
                  persistent-hint :label="$t('message.tickets.subject')"></v-text-field>
              </v-row>
              <v-row>
                <v-flex xs12>
                  <label class="subtitle-1">{{ $t('message.tickets.body') }}</label>
                  <ckeditor :editor="editor" v-model="body" :config="configEditor"></ckeditor>
                </v-flex>
              </v-row>
              <v-row>
                <v-checkbox dense :label="$t('message.common.copy_to_me')" v-model="isCopyToMe" hide-details color="primary"></v-checkbox>
                <v-checkbox dense v-if="isSupplierOrder" class="ml-2" :label="$t('message.whOrder.withLocations')" v-model="isWithLocations" hide-details color="primary"></v-checkbox>
                <v-checkbox dense v-if="isSupplierOrder" class="ml-2" :label="$t('message.whOrder.withPrices')" v-model="isWithPrices" hide-details color="primary"></v-checkbox>
              </v-row>
              <v-row v-if="isSupplierOrder">
                <attach_share v-model="filelist" v-if="shareDialog" :filelist="filelist" :sharepoint="sharepointObj"></attach_share>
              </v-row>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" id="sendMail" :loading="shareLoading" @click="shareReport">{{ $t('message.common.send') }}</v-btn>
            <v-btn color="error" id="close" @click="closeShareDialog">{{ $t('message.common.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-card>
</template>
<script>
/* eslint-disable camelcase */
import reports from '@/mixins/WarehouseOrder/report'
import Editor from '@/ckeditor'
import { mapState } from 'vuex'
// import { getFooter } from '@/constants'
export default {
  data () {
    return {
      shareLoading: false,
      shareDialog: false,
      isSupplierOrder: false,
      mails: '',
      isCopyToMe: false,
      isWithPrices: false,
      isWithLocations: false,
      body: '',
      subject: '',
      editor: Editor,
      filelist: [],
      sharepointObj: {
        loading: false,
        files: []
      },
      settingsObj: {},
      sharepointId: '',
      configEditor: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'undo',
            'redo'
          ]
        }
      }
    }
  },
  computed: {
    ...mapState(['listOfLocations', 'listOfWarehouse'])
  },
  components: {
    'attach_share': () => import('@/components/AttachFileToMail.vue')
  },
  watch: {
    'shareDialog' (val) {
      if (this.orderModel) {
        this.isSupplierOrder = this.orderModel && this.orderModel.type_ref === 'supplier'
        this.subject = `${this.$t('message.common.order_report')} ${this.orderModel.number ? this.orderModel.number : ''} ${this.isSupplierOrder ? (this.orderModel.salesreference ? this.orderModel.salesreference : '') : ''}`
        if (this.isSupplierOrder) {
          this.sharepointId = this.orderModel.sharepoint_id
          this.sharepointObj.files = []
          this.filelist = []
          if (this.sharepointId) this.getAllDocumentsFromSharepoint(this.sharepointId)
        }
      }
      if (val) {
        const { mail_signature } = this.$formatter.cloneVariable(this.settingsObj)
        this.isWithPrices = false
        this.isWithLocations = false
        this.body = mail_signature
      }
    }
  },
  mixins: [reports],
  methods: {
    getAllDocumentsFromSharepoint (id) {
      this.sharepointObj.loading = true
      this.$_executeApi('get', `sharepoint/get_children_documents/${id}`)
        .then((response) => {
          if (response) {
            this.sharepointObj.files = response.data
          }
        })
        .finally(() => {
          this.sharepointObj.loading = false
        })
    }
  }
}
</script>
